<template>
  <div class="invitacion-container">

    <!-- 🌸 FLORES DECORATIVAS EN ESQUINAS -->
    <img ref="florTL" src="@/assets/esq1.png" alt="Decoración" class="decoracion-esquina flor-top-left" />
    <img ref="florBR" src="@/assets/esq1.png" alt="Decoración" class="decoracion-esquina flor-bottom-right" />

    <!-- 🌿 ELEMENTOS DECORATIVOS EN ESQUINAS OPUESTAS -->
    <img ref="elTR" src="@/assets/elemento2.png" alt="Decoración" class="decoracion-esquina el-top-right" />
    <img ref="elBL" src="@/assets/elemento2.png" alt="Decoración" class="decoracion-esquina el-bottom-left" />

    <!-- ✨ ESTRELLAS DESTELANTES (CSS) -->
    <div class="estrellas-container" aria-hidden="true">
      <div class="estrella e1">✦</div>
      <div class="estrella e2">✧</div>
      <div class="estrella e3">✦</div>
      <div class="estrella e4">✦</div>
      <div class="estrella e5">✧</div>
      <div class="estrella e6">✦</div>
      <div class="estrella e7">✧</div>
      <div class="estrella e8">✦</div>
      <div class="estrella e9">✧</div>
      <div class="estrella e10">✦</div>
      <div class="estrella e11">✧</div>
      <div class="estrella e12">✦</div>
      <div class="estrella e13">✧</div>
      <div class="estrella e14">✦</div>
    </div>

    <!-- TARJETA PRINCIPAL -->
    <div class="invitacion-card">
      
      <!-- 👑 CORONA EN EL ENCABEZADO -->
      <img ref="ampersand" src="@/assets/coronaa.png" alt="Corona" class="corona-header" />
      <p ref="familiaSingh" class="nombre-festejada1">La Familia Oconor</p>

      <!-- TEXTO DE INVITACIÓN DIRECTA CON INVITADO -->
      <div class="encabezado-invitacion" ref="encabezadoRef">
        <p v-if="[2, 3, 4].includes(paquete) && welcomeText" ref="invitadoBox" class="texto-bienvenida">
          Estimado(a) <span class="nombre-invitado">{{ welcomeText }}</span>,<br>
          <i>tenemos el honor de invitarte a la</i>
        </p>
        <p v-else class="texto-bienvenida">
          <i>Tiene el honor de invitarte a la</i>
        </p>
      </div>

      <!-- TEXTO PRINCIPAL Y NOMBRE DE LA FESTEJADA -->
      <h1 ref="titulo" class="titulo-quinceanera">QUINCEAÑERA</h1>
      <span ref="deTexto" class="de-texto">de</span>
      <p ref="nombres" class="nombre-festejada">Elizabeth Oconor</p>

      <div v-if="[3, 4].includes(paquete) && (numpase || mesaText)" ref="detallesReservaRef" class="detalles-reserva">
        <p v-if="[3, 4].includes(paquete) && numpase" ref="paseRef" class="texto-pase">
         Pases reservados: <strong>{{ numpase }}</strong> 
        </p>
        <p v-if="paquete === 4 && mesaText" ref="mesaRef" class="texto-mesa">
           Mesa asignada: <strong>{{ mesaText }}</strong>
        </p>
      </div>

      <!-- ✉️ SOBRE PRINCIPAL -->
      <div class="sobre-wrapper" ref="sobreRef">
        <img src="@/assets/sobre.png" alt="Sobre de invitación" class="sobre-img" />
      </div>

      <!-- SECCIÓN SELECCIÓN DE IDIOMA / BOTONES -->
      <div class="seccion-idiomas" ref="idiomaSeccion">
        <p class="instruccion-idioma">
          CHOOSE YOUR LANGUAGE<br>
          <i>Seleccione su idioma</i>
        </p>
        
        <div class="opciones-idioma">
          <button @click="seleccionar('en')" class="btn-idioma">ENGLISH</button>
          <button @click="seleccionar('es')" class="btn-idioma">SPANISH</button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, watch, nextTick } from 'vue';
import { gsap } from 'gsap';
import axios from 'axios';
import baseUrl from '@/api';

export default {
  name: 'InvitacionIdioma',
  props: {
    idInvitado: [Number, String],
    nombre: String,
    idFestejado: [Number, String]
  },
  emits: ['idioma-seleccionado'],
  setup(props, { emit }) {
    // Referencias GSAP
    const ampersand = ref(null);
    const familiaSingh = ref(null);
    const encabezadoRef = ref(null);
    const titulo = ref(null);
    const deTexto = ref(null);
    const nombres = ref(null);
    const detallesReservaRef = ref(null);
    const sobreRef = ref(null);
    const idiomaSeccion = ref(null);
    
    // Esquinas decorativas
    const florTL = ref(null);
    const florBR = ref(null);
    const elTR = ref(null);
    const elBL = ref(null);

    // Dinámicas de invitado
    const invitadoBox = ref(null);
    const paseRef = ref(null);
    const mesaRef = ref(null);

    let ctx;

    // Estado reactivo
    const welcomeText = ref('');
    const mesaText = ref('');
    const numpase = ref(null);
    const paquete = ref(null);

    // Consulta de datos de la API
    const fetchData = async () => {
      const parsedId = Number(props.idInvitado);
      if (!isNaN(parsedId) && parsedId > 0) {
        try {
          const url = `${baseUrl}/${props.nombre || ''}/${props.idFestejado || ''}/${parsedId}`;
          const response = await axios.get(url);
          
          welcomeText.value = response.data.nombre_mostrar;
          mesaText.value = response.data.num_mesa;
          numpase.value = response.data.num_pase;
          paquete.value = Number(response.data.paquete);

          await nextTick();
          iniciarAnimacionSecuencial();
        } catch (err) {
          console.error('Error al obtener los datos del invitado:', err);
          iniciarAnimacionSecuencial();
        }
      } else {
        iniciarAnimacionSecuencial();
      }
    };

    // Secuencia GSAP estricta de arriba hacia abajo
    const iniciarAnimacionSecuencial = () => {
      if (ctx) ctx.revert();

      ctx = gsap.context(() => {
        const tl = gsap.timeline({ delay: 0.1 });

        // 🌸 1. Esquinas decorativas
        tl.from([florTL.value, florBR.value, elTR.value, elBL.value], {
          opacity: 0,
          scale: 0.8,
          duration: 0.8,
          stagger: 0.1,
          ease: 'power2.out'
        })
        // 👑 2. Corona arriba
        .from(ampersand.value, {
          scale: 0,
          opacity: 0,
          y: -25,
          duration: 0.8,
          ease: 'back.out(1.8)'
        }, '-=0.5')
        // 🏰 2.1. Familia Singh
        .from(familiaSingh.value, {
          opacity: 0,
          y: -15,
          duration: 0.7,
          ease: 'power2.out'
        }, '-=0.4')
        // 📜 3. Texto del encabezado / Nombre invitado
        .from(encabezadoRef.value, {
          opacity: 0,
          y: -10,
          duration: 0.6,
          ease: 'power2.out'
        }, '-=0.3')
        // ✨ 4. Título QUINCEAÑERA
        .from(titulo.value, {
          opacity: 0,
          scale: 0.85,
          letterSpacing: '1px',
          duration: 0.7,
          ease: 'power3.out'
        }, '-=0.2')
        // ✒️ 5. Conector "de"
        .from(deTexto.value, {
          opacity: 0,
          scale: 0.5,
          duration: 0.4,
          ease: 'back.out(2)'
        }, '-=0.3')
        // 💖 6. Nombre de la Festejada
        .from(nombres.value, {
          opacity: 0,
          y: 15,
          duration: 0.8,
          ease: 'power3.out'
        }, '-=0.2')
        // ✉️ 7. Sobre flotante
        .from(sobreRef.value, {
          opacity: 0,
          scale: 0.8,
          y: 15,
          duration: 0.7,
          ease: 'back.out(1.4)'
        }, '-=0.3');

        // 🎟️ 8. MESA Y PASES
        const elementosReserva = [paseRef.value, mesaRef.value].filter(Boolean);
        if (elementosReserva.length > 0) {
          tl.from(elementosReserva, {
            opacity: 0,
            y: 15,
            scale: 0.9,
            duration: 0.6,
            stagger: 0.2,
            ease: 'back.out(1.6)'
          }, '-=0.2');
        }

        // 🔘 9. Botones de idioma
        tl.from(idiomaSeccion.value, {
          opacity: 0,
          y: 20,
          duration: 0.6,
          ease: 'power2.out'
        }, '-=0.2');
      });
    };

    const seleccionar = (idioma) => {
      emit('idioma-seleccionado', idioma);
    };

    onMounted(() => {
      fetchData();
    });

    onUnmounted(() => {
      if (ctx) ctx.revert();
    });

    watch(() => props.idInvitado, () => {
      fetchData();
    });

    return {
      seleccionar,
      ampersand,
      familiaSingh,
      encabezadoRef,
      titulo,
      deTexto,
      nombres,
      detallesReservaRef,
      sobreRef,
      idiomaSeccion,
      florTL,
      florBR,
      elTR,
      elBL,
      invitadoBox,
      paseRef,
      mesaRef,
      welcomeText,
      mesaText,
      numpase,
      paquete
    };
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Great+Vibes&family=Montserrat:ital,wght@0,300;0,400;0,500;1,300;1,400&display=swap');

/* CONTENEDOR GENERAL */
.invitacion-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 1rem 0.5rem;
  background: radial-gradient(circle, #022d38 0%, #012d2b 100%);
  position: relative;
  overflow: hidden;
}

/* 🌸 DECORACIONES */
.decoracion-esquina {
  position: absolute;
  width: 220px;
  height: auto;
  pointer-events: none;
  z-index: 1;
}

.flor-top-left { top: -25px; left: -25px; opacity: 0.4; }
.flor-bottom-right { bottom: -25px; right: -25px; opacity: 0.4; transform: rotate(180deg); }
.el-top-right { top: -12px; right: -12px; opacity: 0.3; width: 170px; }
.el-bottom-left { bottom: -12px; left: -12px; opacity: 0.3; width: 170px; transform: rotate(180deg); }

/* ✨ ESTRELLAS */
.estrellas-container {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}

.estrella {
  position: absolute;
  color: #B28F60;
  text-shadow: 0 0 6px rgba(178, 143, 96, 0.8), 0 0 12px rgba(178, 143, 96, 0.4);
  animation: brillo 2.5s infinite ease-in-out;
}

.e1 { top: 12%; left: 8%; font-size: 1.1rem; animation-delay: 0s; }
.e2 { top: 25%; right: 12%; font-size: 1rem; animation-delay: 0.6s; }
.e3 { top: 40%; left: 5%; font-size: 1.3rem; animation-delay: 1.2s; }
.e4 { top: 55%; right: 8%; font-size: 0.9rem; animation-delay: 1.8s; }
.e5 { top: 70%; left: 10%; font-size: 1.1rem; animation-delay: 0.4s; }
.e6 { top: 20%; left: 88%; font-size: 1.2rem; animation-delay: 0.9s; }
.e7 { top: 82%; right: 15%; font-size: 1.3rem; animation-delay: 1.5s; }
.e8 { top: 15%; left: 48%; font-size: 0.8rem; animation-delay: 0.3s; }
.e9 { top: 35%; left: 82%; font-size: 1rem; animation-delay: 1.1s; }
.e10 { top: 65%; right: 88%; font-size: 1.2rem; animation-delay: 0.7s; }
.e11 { top: 78%; left: 35%; font-size: 0.9rem; animation-delay: 1.4s; }
.e12 { top: 48%; left: 18%; font-size: 1.1rem; animation-delay: 0.2s; }
.e13 { top: 90%; left: 75%; font-size: 1rem; animation-delay: 1.7s; }
.e14 { top: 5%; right: 30%; font-size: 1.2rem; animation-delay: 0.8s; }

@keyframes brillo {
  0%, 100% { opacity: 0.2; transform: scale(0.8); }
  50% { opacity: 1; transform: scale(1.2); }
}

/* TARJETA PRINCIPAL (Más ancha y con menos margen lateral) */
.invitacion-card {
  position: relative;
  padding: 10px 5px;
  margin: 0 auto;
  text-align: center;
  width: 100%;
  max-width: 460px;
  z-index: 2;
}

.corona-header {
  width: 155px;
  height: auto;
 
  margin: 0 auto 6px;
  display: block;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.5));
}

.encabezado-invitacion {
  margin-bottom: 0.7rem;
    margin-top:-20px;

}

.texto-bienvenida {
  font-family: 'Cinzel', serif;
  font-size: 0.98rem;
  color: #f3e5e8;
  line-height: 1.45;
  margin: 0;
}

.texto-bienvenida i {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.9rem;
  font-style: italic;
  font-weight: 300;
}

.nombre-invitado {
  font-family: 'Great Vibes', cursive;
  font-size: 2.2rem;
  color: #ffffff;
  font-weight: 400;
  display: inline-block;
  margin: 2px 0;
}

.titulo-quinceanera {
  font-family: 'Cinzel', serif;
  font-size: 1.85rem;
  color: #B28F60;
  letter-spacing: 3.5px;
  font-weight: 600;
  margin: 0;
}

.de-texto {
  font-family: 'Great Vibes', cursive;
  font-size: 1.6rem;
  color: #fce8eb;
  display: block;
  margin: -6px 0;
}
.nombre-festejada1 {
  font-family: 'Great Vibes', cursive;
  font-size: 2.7rem !important;
  color: #B28F60;
  margin: 0 0 0.6rem 0;
  font-weight: 400;
  text-shadow: 0 2px 6px rgba(0,0,0,0.4);
  line-height: 1.1;
}
.nombre-festejada {
  font-family: 'Great Vibes', cursive;
  font-size: 3.8rem !important;
  color: #B28F60;
  margin: 0 0 0.6rem 0;
  font-weight: 400;
  text-shadow: 0 2px 6px rgba(0,0,0,0.4);
  line-height: 1.1;
}

.detalles-reserva {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.92rem;
  color: #fce8eb;
  margin-bottom: 0.9rem;
  display: flex;
  justify-content: center;
  gap: 18px;
}

.detalles-reserva p {
  margin: 0;
}

.texto-pase strong,
.texto-mesa strong {
  color: #ffe58f;
  font-weight: 600;
}

.sobre-wrapper {
  margin: 5px auto 15px;
  max-width: 135px;
}

.sobre-img {
  width: 100%;
  height: auto;
  filter: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.6));
}

/* BOTONES DE IDIOMA */
.seccion-idiomas {
  margin-top: 1.2rem;
}

.instruccion-idioma {
  font-family: 'Cinzel', serif;
  font-size: 0.9rem;
  color: #ffffff;
  letter-spacing: 1.5px;
  margin-bottom: 0.9rem;
  line-height: 1.35;
}

.instruccion-idioma i {
  font-family: 'Montserrat', sans-serif;
  font-size: 0.85rem;
  font-style: italic;
  letter-spacing: 0px;
  text-transform: none;
  display: block;
}

.opciones-idioma {
  display: flex;
  justify-content: center;
  gap: 14px;
}

.btn-idioma {
  flex: 1;
  max-width: 145px;
  padding: 10px 14px;
  font-size: 1rem;
  font-family: 'Cinzel', serif;
  font-weight: 800;
  letter-spacing: 1px;

  background-image: url('@/assets/dorado.jpeg');
  background-size: cover;
  background-position: center;
  background-color: #bf953f;

  color: #000000 !important;
  -webkit-text-fill-color: #1a1a1a !important;
  text-decoration: none;
  border-radius: 22px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.btn-idioma:hover {

  background-image: url('@/assets/dorado.jpeg');
  background-size: cover;
  background-position: center;
  background-color: #bf953f;

  color: #000000 !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.6);
}

</style>